export default `mutation setPaymentMethodOnCart ($input: SetPaymentMethodOnCartInput) {
  setPaymentMethodOnCart (input: $input) {
    cart {
      shipping_addresses {
        selected_shipping_method{
          amount {
            currency
            value
          }
          carrier_code
          carrier_title
          method_code
          method_title
        }
      }
    }
  }
}
`
